// delay for user interactions such as the debounce wait for autosuggest
export const userDelayMs = 250

// field name constants to ensure consistency in mapping server errors to form fields
export const fieldNames = {
  birthDate: 'birthDate',
  contactId: 'contactId',
  location: 'location',
  email: 'email',
  emailVerified: 'emailVerified',
  gender: 'gender',
  firstNames: 'firstNames',
  lastNames: 'lastNames',
  churchRecordNumber: 'churchRecordNumber',
  smsCountry: 'smsCountry',
  smsNumber: 'smsNumber',
  smsVerified: 'smsVerified',
  whatsAppCountry: 'whatsAppCountry',
  whatsAppNumber: 'whatsAppNumber',
  userId: 'userId',
  username: 'username',
  treeStartingPersonId: 'treeStartingPersonId',
  verificationCode: 'code',
  currentPassword: 'currentPassword',
  newPassword: 'newPassword',
  helperPin: 'helperPin',
  citizen: 'citizen',
  receiveMessages: 'receiveMessages',
}

export const citizenOptions = {
  UNSPECIFIED: 'unspecified',
  NO: 'false',
  YES: 'true',
}

export const signOutLink = '/auth/familysearch/logout'
